import styled from 'styled-components';

import { ChevronIcon } from '../../assets';
import { ThemeProp } from '../../theme/Themes';
import DateRangePicker from '../DateRangePicker';

interface StyledButtonProps {
  $isActive: boolean;
}

const getHoverColor = (props: ThemeProp & StyledButtonProps) => {
  if (props.$isActive) {
    return props.theme.colors.primary.c500;
  }
  return props.theme.colors.neutrals.white;
};

export const StyledButton = styled.div<StyledButtonProps>`
  display: flex;
  align-items: center;
  background: transparent;
  color: ${(props: ThemeProp & StyledButtonProps) =>
    props?.$isActive ? props.theme.colors.primary.c500 : props.theme.colors.neutrals.c300};
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontVariants.desktop.body.sm.fontSize};
  line-height: ${({ theme }) => theme.fontVariants.desktop.body.sm.lineHeight};
  padding: 0.25rem;
  height: 2rem;
  cursor: pointer;
  min-width: 8rem;
  gap: 0.5rem;

  svg {
    fill: ${({ theme }) => theme.colors.primary.c500};
    width: 1rem;
    height: 1rem;
  }

  &:hover {
    color: ${(props: ThemeProp & StyledButtonProps) => getHoverColor(props)};
    background-color: ${({ theme }) => theme.colors.neutrals.c700};
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.neutrals.c800};
  border: 1px solid ${({ theme }) => theme.colors.neutrals.c600};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
`;

export const SelectedOptionButton = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.375rem;
  padding: 0.625rem 0.75rem;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontVariants.desktop.buttons.sm.fontSize};
  line-height: ${({ theme }) => theme.fontVariants.desktop.buttons.sm.lineHeight};
  color: ${({ theme }) => theme.colors.neutrals.white};
  border: 1px solid ${({ theme }) => theme.colors.neutrals.c500};
  cursor: pointer;
  height: 2.5rem;
  text-wrap: nowrap;
  white-space: nowrap;
  overflow: visible;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    background-color: ${({ theme }) => theme.colors.neutrals.c800};
    margin-left: 0;
  }
`;

interface StyledChevronIconProps {
  $shouldRotate: boolean;
}

export const StyledChevronIcon = styled(ChevronIcon)<StyledChevronIconProps>`
  flex: 1 0 0.625rem;
  stroke: ${({ theme }) => theme.colors.neutrals.white};
  align-self: center;
  width: 0.75rem;
  height: 0.75rem;
  ${({ $shouldRotate }) => ($shouldRotate ? 'transform: rotate(180deg);' : '')}
`;

export const StyledDateRangePicker = styled(DateRangePicker)`
  padding-top: 1rem;
  border-left: 1px solid ${({ theme }) => theme.colors.neutrals.c700};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    border-left: none;
    padding-top: 0;
  }
`;

export const MobileOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
`;

export const ButtonExtraDataContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${({ theme }) => theme.colors.neutrals.c300};

  svg {
    width: 1.25rem;
    stroke: white;
  }
`;
